import type { components } from '@connected/api-client/api.generated';

import type { CompletionFormValues } from './completion-types';

export function calculateFactor({ values, intervalQuestions }: { values: CompletionFormValues; intervalQuestions: components['schemas']['EditElectricalProjectInspectionConclusionQueryResultIntervalQuestions'] }) {
    const {
        intervalQuestions: {
            determineInspectionIntervalAge,
            determineInspectionIntervalEnvironment,
            determineInspectionIntervalQuality,
            determineInspectionIntervalSupervision,
            determineInspectionIntervalUsers,
        },
    } = values;

    const item1 = intervalQuestions.DetermineInspectionIntervalAgeList?.find(item => item.Kind === determineInspectionIntervalAge)?.Weight ?? 0;
    const item2 = intervalQuestions.DetermineInspectionIntervalEnvironmentList?.find(item => item.Kind === determineInspectionIntervalEnvironment)?.Weight ?? 0;
    const item3 = intervalQuestions.DetermineInspectionIntervalQualityList?.find(item => item.Kind === determineInspectionIntervalQuality)?.Weight ?? 0;
    const item4 = intervalQuestions.DetermineInspectionIntervalSupervisionList?.find(item => item.Kind === determineInspectionIntervalSupervision)?.Weight ?? 0;
    const item5 = intervalQuestions.DetermineInspectionIntervalUsersList?.find(item => item.Kind === determineInspectionIntervalUsers)?.Weight ?? 0;

    const total = item1 + item2 + item3 + item4 + item5;

    /*
    1 t/m 2 = eens per 6 jaar

    3 t/m 6 = eens per 5 jaar

    7 t/m 10 = eens per 4 jaar

    11 t/m 16 = eens per 3 jaar,

    17 t/m 25 = eens per 2 jaar

    meer dan 25 eens per jaar
    */

    let interval: number;
    if (total <= 2) {
        interval = 6;
    }
    else if (total <= 6) {
        interval = 5;
    }
    else if (total <= 10) {
        interval = 4;
    }
    else if (total <= 16) {
        interval = 3;
    }
    else if (total <= 25) {
        interval = 2;
    }
    else {
        interval = 1;
    }

    return {
        factor: total,
        interval,
    };
}
